<div class="login-container">
  <div class="login-container-box">
    <h4 class="playfair mb-2">Авторизация</h4>
    <form [formGroup]="loginGroup">
      <div class="login-container-box-item">
        <label>Пользователь</label>
        <input
          id="login"
          type="text"
          inputmode="text"
          formControlName="username"
        />
      </div>
      <div class="login-container-box-item">
        <label>Пароль</label>
        <input
          id="password"
          type="password"
          inputmode="text"
          formControlName="password"
        />
      </div>
      <div class="login-container-box-item">
        <div (click)="login()" class="login-container-box-item-button">
          <h6>Войти</h6>
        </div>
      </div>
      <div class="login-container-box-item login-container-box-item-error">
        {{ error }}
      </div>
    </form>
  </div>
</div>
